export default function WebSkills() {
  const react = 90;
  const nodejs = 60;
  const expressjs = 80;
  const mongodb = 70;
  const sass = 70;
  const materialUI = 80;
  const restAPI = 80;

  return (
    <>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>React</p>
            <h6>{react}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${react}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Node JS</p>
            <h6>{nodejs}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${nodejs}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Express JS</p>
            <h6>{expressjs}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${expressjs}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Mongo DB</p>
            <h6>{mongodb}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${mongodb}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Sass</p>
            <h6>{sass}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${sass}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Material UI</p>
            <h6>{materialUI}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${materialUI}%` }}></div>
        </div>
      </div>
      <div data-aos="fade-up" className="col-md-6 mb-3 col-sm-12 ">
        <div className="skill">
          <div className="d-flex align-items-center justify-content-between">
            <p>Rest API</p>
            <h6>{restAPI}%</h6>
          </div>
          <div className="skillMeter" style={{ width: `${restAPI}%` }}></div>
        </div>
      </div>
    </>
  );
}
